<div class="color-picker">
  <input
    type="color"
    class="swatch"
    [value]="hexValue ?? '#000000'"
    [disabled]="disabled"
    (input)="onSwatchChange($any($event.target).value)"
    [attr.aria-label]="'label.rgb_color_input' | translate"
    data-cy="color-picker-swatch"
  />
  <input
    type="text"
    class="hex-input"
    [value]="textValue"
    [disabled]="disabled"
    (input)="onTextChange($any($event.target).value)"
    placeholder="#rrggbb"
    spellcheck="false"
    autocomplete="off"
    data-cy="color-picker-hex"
  />
</div>
